import React, { useState, useEffect } from "react";
import {
  FaGithub,
  FaShareSquare,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import { Loading } from ".";
import AIRTABLE_DATA from "../data/airtableData";
import { useI18n } from "../i18n";

export const Projects = () => {
  const [projects, setProjects] = useState();
  const [loading, setLoading] = useState(true);
  const { t, locale } = useI18n();

  const fetchProjects = async () => {
    const projects = [...AIRTABLE_DATA.featuredProjects].sort(
      (a, b) => a.order - b.order
    );
    setProjects(projects);
    setLoading(false);
  };

  // useEffect
  useEffect(() => {
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // jsx
  return (
    <section className="section projects" id="projects">
      {/* title */}
      <div className="section-title">
        <h2>
          {t.projects.titleA} <span>{t.projects.titleB}</span>
        </h2>
        <div className="underline"></div>
        <p>{t.projects.intro}</p>
      </div>

      {/* projects-center */}
      <div className="section-center projects-center">
        {loading ? (
          <Loading />
        ) : (
          <>
            {projects.map((project) => (
              <SingleProject
                key={project.id}
                {...project}
                title={project.title[locale]}
                desc={project.desc[locale]}
                t={t}
              />
            ))}
          </>
        )}
      </div>
    </section>
  );
};

const SingleProject = ({
  imgUrl,
  title,
  desc,
  stack,
  url,
  github,
  isClientWork,
  t,
}) => {
  const [showDesc, setShowDesc] = useState(false);

  // jsx
  return (
    <article className="project">
      {/* image */}
      <div className="project-img">
        <img
          src={imgUrl}
          alt={`${t.projects.screenshotOf} ${title}`}
          className="project-image"
          width="640"
          height="400"
          loading="lazy"
        />
      </div>
      <div className="project-details">
        {/* info */}
        <div className="project-info">
          <h3 className="project-title">{title}</h3>

          <button
            className="project-text-toggle"
            onClick={() => setShowDesc(!showDesc)}
            aria-expanded={showDesc}
          >
            {t.projects.description}{" "}
            {showDesc ? (
              <FaAngleUp className="fa" />
            ) : (
              <FaAngleDown className="fa" />
            )}
          </button>

          <p className={`project-text ${showDesc ? "show-project-text" : ""}`}>
            {desc}
          </p>

          <div className="project-tools">
            {stack.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </div>
        </div>

        {/* footer */}
        <div className="project-footer">
          <a href={url} target="_blank" rel="noreferrer" title={title}>
            <strong>
              <FaShareSquare className="fa" /> <span>{t.projects.live}</span>
            </strong>
          </a>
          {!isClientWork && github && (
            <a
              href={github}
              target="_blank"
              rel="noreferrer"
              title={`${title} — GitHub`}
            >
              <FaGithub className="fa" /> <span>{t.projects.source}</span>
            </a>
          )}
        </div>
      </div>
    </article>
  );
};
